/* jshint esversion: 6 */

import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import axios from 'axios'

Vue.use(Vuex)

// let token = document.getElementsByName('csrf-token')[0].getAttribute('content')
// axios.defaults.headers.common['X-CSRF-Token'] = token
axios.defaults.headers.common[ 'Accept' ] = 'application/json'

console.log( process.env.NODE_ENV )
const root_path = ( process.env.NODE_ENV == "production" ) ? 'https://arbogast.at/programm/api/v2/'
                                                           : "http://localhost:3000/programm/api/v2/";

// const root_asset_path = '/fileadmin/packs'
const root_asset_path = '/fileadmin/packs'

// const root_attachment_path = 'programm'
const root_attachment_path = '/programm'

export default new Vuex.Store({
  plugins: [ createPersistedState() ],
  state: {
    media_formats: {
      audio: true,
      video: false
    },
    categories: [],
    agendas: [],
    playlist: [],
    error: {},
    search: '',
    filter_by_referents: [],
    filter_by_categories: [],
    filter_by_format: [],
    filter_by_date: {},
    filter_by_search: '',
    display_type: 'list',

    login_in_process: false,
    order_in_process: false,
    logged_in: false,
    wait_for_login_token: false,
    display_basket: true,
    display_agenda_as: 'list',
  },
  getters: {
    const () {
      return {
        root_path: root_path,
        root_asset_path: root_asset_path,
        root_attachment_path: root_attachment_path
      }
    },
    categories: (state) => state.categories,
    agendas: (state) => state.agendas,
    referents: ( state ) => {
      let referents = []
      state.agendas.forEach( a => {
        if( a.referents && a.referents.length > 0 ) {
          a.referents.forEach( r => {
            if( ! referents.find( f => r.id == f.id )) {
              referents.push( r )
            }
          })
        }
      })
      return referents
    },

    get_agenda_filtered_by_referents: (state) => {
      const referent_ids = state.filter_by_referents.map( r => r.id )
      // console.log('get_agenda_filter_by_referents: ', referent_ids)
      if (state.filter_by_referents.length <= 0) {
        return state.agendas
      }
      return state.agendas.filter(a => {
        return a.referents.some(r => {
          return referent_ids.indexOf(r.id) >= 0
        })
      })
    },

    get_agenda_filtered_by_categories: (state) => {
      const cat_ids = state.filter_by_categories.map( c => c.id )
      // console.log('get_agenda_filter_by_categories: ', cat_ids)
      if (state.filter_by_categories.length <= 0) {
        return state.agendas
      }
      return state.agendas.filter(a => {
        return a.categories.some(c => {
          return cat_ids.indexOf(c.id) >= 0
        })
      })
    },

    get_filtered: (state, getters) => {
      if (state.filter_by_referents.length > 0 ) {
        return getters.get_agenda_filtered_by_referents
      } else {
        return getters.get_agenda_filtered_by_categories
      }
    },

    get_agenda_filtered_by_date: (state) => (data) => {
      return data.filter(x => x.start_date.indexOf(filter) >= 0)
    },

    get_agenda_filtered_by_search: (state) => (data) => {
      return data.filter(x => {
        // console.log(x)
        return x.title.toLowerCase().indexOf(state.filter_by_search.toLowerCase()) >= 0 ||
          String(x.subtitle).toLowerCase().indexOf(state.filter_by_search.toLowerCase()) >= 0
      })
    },

    filtered_agendas: (state, getters) => {
      // console.log('state:getters:filtered_agendas')
      var ret = getters.agendas
      if (state.filter_by_search > '') {
        ret = getters.get_agenda_filtered_by_search(ret)
      }
      if (getters.categories_active.length > 0) {
        ret = getters.get_agenda_filtered_by_categories(ret)
      }
      return ret
    },

    in_playlist: (state) => (id) => {
      if( !state.playlist || state.playlist.length <= 0 ) return false
      return state.playlist.find( (a) => a.id === id ) !== undefined
    },
  },

  // ----------------------------------------------------
  //
  // ----------------------------------------------------
  mutations: {
    CHANGE_DISPLAY_TYPE ( state, type ) {
      state.display_type = type
    },
    SET_FILTER_SEARCH (state, search) {
      state.filter_by_search = search
    },
    SET_FILTER_DATE (state, year, month) {
      state.filter_by_date = { year: year, month: month }
    },
    SET_ERROR (state, error) {
      state.error = error
    },
    SET_AGENDAS (state, agendas) {
      // console.log(agendas)
      state.agendas = agendas
    },
    SET_CATEGORIES (state, categories) {
      let t = []
      categories.forEach((x) => {
        x.active = false
        if (x.id) t.push(x)
      })
      state.categories = t
    },
    ADD_TO_PLAYLIST (state, id) {
      if( ! state.playlist.find( a => a.id === id ) ) {
        let item = state.agendas.find( a => a.id === id )
        state.playlist.push( item )
      }
    },
    REMOVE_FROM_PLAYLIST (state, id) {
      const item = state.playlist.find( a => a.id === id )
      if (item) state.playlist.splice(state.playlist.indexOf(item), 1);
    }
  },

  // ----------------------------------------------------------
  //
  //
  //
  // ----------------------------------------------------------
  actions: {
    logout ({ commit }) {
      commit('CLEAR_LOGIN')
    },
    set_filter_search ({ state, commit }, search) {
      commit('SET_FILTER_SEARCH', search)
    },
    set_filter_date ({ state, commit }, year, month) {
      commit('SET_FILTER_DATE', year, month)
    },
    change_display_type ({ state, commit }, type ) {
      commit( 'CHANGE_DISPLAY_TYPE', type )
    },
    request_login ({ state, commit }, email) {
      commit('CLEAR_LOGIN')
      axios.post(root_path + 'login_sessions', {
        email: email
      }).then((response) => {
        // console.log(response)
        state.email = email
        commit('SET_LOGIN_WAIT_FOR_TOKEN')
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    commit_token ({ state, commit }, token) {
      axios.post(root_path + 'login_sessions/activate', {
        token: token
      }).then((response) => {
        // console.log('token ok ', response)
        if (response.data.status === 200) {
          commit('SET_LOGIN', response.data.profil)
        } else {
          commit('SET_ERROR', { status: response.data.status, message: response.data.message })
        }
      }).catch(error => {
        console.log('token error: ', error)
      })
    },
    find_category_title ({ state }, slug) {
      return new Promise((resolve, reject) => {
        // console.log('action - find_category_title ', state.categories)
        resolve(state.categories.find((c) => {
          console.log(c.slug === slug)
          return c.slug === slug
        }))
      })
    },
    add_to_playlist( { commit }, agenda ) {
      // console.log( 'add to playlist', agenda )
      commit('ADD_TO_PLAYLIST', agenda )
    },
    empty_playlist ({ commit }) {
      commit('EMPTY_PLAYLIST')
    },
    remove_from_playlist ({ commit }, agenda ) {
      commit('REMOVE_FROM_PLAYLIST', agenda)
    },
    get_categories ({ commit }) {
      axios.get(root_path + 'categories.json').then((response) => {
        commit('SET_CATEGORIES', response.data)
      })
    },
    get_agendas ({ commit }, path = 'all') {
      axios.get(root_path + 'audios/' + path + '.json', {
        params: {
          search: '%'
        }
      }).then((response) => {
        commit('SET_AGENDAS', response.data)
      }).catch(error => {
        console.log('error: ', error)
      })
    },
    toggle_playlist ( { commit, getters }, id ) {
      if( getters.in_playlist( id ) ) {
        commit( 'REMOVE_FROM_PLAYLIST', id )
      } else {
        commit( 'ADD_TO_PLAYLIST', id )
      }
      console.log( this.playlist )
    },

  }
})
